var _rect, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.54531,
    y: 0.6,
    width: 28.3556,
    height: 17.8,
    rx: 2.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.54531,
    y1: 6.25938,
    x2: 29.9009,
    y2: 6.25938,
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.4453,
    y1: 15.8594,
    x2: 21.5564,
    y2: 15.8594,
    stroke: "black",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23.6133,
    y1: 15.8594,
    x2: 24.7244,
    y2: 15.8594,
    stroke: "black",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 26.7773,
    y1: 15.8594,
    x2: 27.8885,
    y2: 15.8594,
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackId);
export default __webpack_public_path__ + "static/media/back-id.9cb11930030f62099e934a8d8d407151.svg";
export { ForwardRef as ReactComponent };